export enum RemittanceStatusEnum {
  PROCESSING = 'Processing',
  COMPLETE = 'Complete',
  INCOMPLETE = 'Incomplete'
}
